module.exports = __webpack_public_path__ + "media/images/background/bg-shape-2-6a1de272f86bc4234929fd1c7389b251.jpg";